import React from 'react';
import { MapPin, Zap, Square } from 'lucide-react';

const SolarPotentialStatisticsGrid = ({ solarStatistics }) => {
  if (!solarStatistics) {
    return null;
  }

  return (
    <div className="flex min-w-0 flex-wrap gap-2">
      <div className="bg-gray-50 rounded p-2 flex-shrink-0">
        <div className="flex items-center">
          <MapPin className="h-4 w-4 text-gray-600 mr-2" />
          <div>
            <p className="text-xs text-gray-600">Zones</p>
            <p className="text-sm font-bold">{solarStatistics.total_cells.toLocaleString()}</p>
          </div>
        </div>
      </div>
      <div className="bg-gray-50 rounded p-2 flex-shrink-0">
        <div className="flex items-center">
          <Zap className="h-4 w-4 text-gray-600 mr-2" />
          <div>
            <p className="text-xs text-gray-600">Capacity</p>
            <p className="text-sm font-bold">
              {(solarStatistics.total_capacity_mw / 1000).toLocaleString(undefined, { maximumFractionDigits: 1 })} GW
            </p>
          </div>
        </div>
      </div>
      <div className="bg-gray-50 rounded p-2 flex-shrink-0">
        <div className="flex items-center">
          <Square className="h-4 w-4 text-gray-600 mr-2" />
          <div>
            <p className="text-xs text-gray-600">Suitable Area</p>
            <p className="text-sm font-bold">{solarStatistics.total_suitable_area_km2.toLocaleString()} km²</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SolarPotentialStatisticsGrid;
